import { Location } from '@angular/common';
import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { from } from 'rxjs';
import { AuthService } from './auth.service';
import { environment } from 'src/environments/environment';

const allowedUrls = [environment.v2ApiUri];

@Injectable({ providedIn: 'root' })
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService, private location: Location) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return from(this.handle(req, next));
  }

  async handle(req: HttpRequest<any>, next: HttpHandler) {
    if (!allowedUrls.some((url) => req.url.includes(url))) {
      return next.handle(req).toPromise();
    }

    const accessToken = await this.authService.getAccessToken();

    if (!accessToken) return next.handle(req).toPromise();

    const authReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return next.handle(authReq).toPromise();
  }
}
